import React from 'react';

import { LinkButton } from '../common/LinkButton/LinkButton';
import { ConnectionString } from '../connect-subscription/ConnectionString.view';
import KeyValue from '../key-value';

import { TestID } from '../../testID';

type ConnectionDetails = {
  Status?: React.ReactNode;
  'Default URL'?: React.ReactNode;
  'Public IP'?: string;
  'Private IP'?: string;
};

export const ConnectionStatus: React.FC<{
  couldNotConnectDefault?: boolean;
  defaultUrl?: string;
  connected: boolean;
  connectDefault?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disconnect?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleOpenFailedModal: (event: React.MouseEvent<HTMLButtonElement>) => void;
  pleaseWait: boolean;
  publicIp?: string;
  privateIp?: string;
  url?: string;
}> = ({
  couldNotConnectDefault,
  defaultUrl,
  disconnect,
  connected,
  connectDefault,
  handleOpenFailedModal,
  pleaseWait,
  publicIp,
  privateIp,
  url,
}) => {
  const details: ConnectionDetails = {
    'Default URL': defaultUrl ? <ConnectionString url={defaultUrl} size="large" /> : 'Not set',
  };

  if (connected) {
    details.Status = (
      <div>
        Connected to {url && <ConnectionString url={url} size="large" />}{' '}
        <LinkButton data-testid={TestID.DisconnectNetworkLinkButton} onClick={disconnect}>
          Disconnect
        </LinkButton>
      </div>
    );
  } else {
    details.Status = (
      <div>
        {couldNotConnectDefault ? 'Connection failed. ' : 'Disconnected. '}
        {couldNotConnectDefault && (
          <LinkButton onClick={handleOpenFailedModal}>Details</LinkButton>
        )}{' '}
        <LinkButton
          disabled={pleaseWait}
          onClick={connectDefault}
          data-testid={
            pleaseWait ? TestID.ConnectingNetworkLinkButton : TestID.ConnectNetworkLinkButton
          }
        >
          {pleaseWait ? 'Connecting' : 'Connect'}
        </LinkButton>
      </div>
    );
  }

  if (publicIp) {
    details['Public IP'] = publicIp;
  }

  if (privateIp) {
    details['Private IP'] = privateIp;
  }

  return <KeyValue list={details} />;
};
